import { reactive, ref, toRefs } from 'vue';

type dialogType = {
  idName?: string;
  initFormParam?: Object;
  getDetailsApi?: (id: string) => Promise<any>;
  dataCallBack?: Function;
  afterOpenDialog?: Function;
  addTitle?: string;
  editTitle?: string;
};

export default function useDialog({
  idName = 'id',
  initFormParam = {},
  getDetailsApi,
  dataCallBack,
  afterOpenDialog,
  addTitle = '新增',
  editTitle = '编辑',
}: dialogType) {
  const state = reactive({
    isShow: false,
    title: addTitle,
    id: '',
  });

  // 表单数据
  const form = ref({ ...initFormParam });
  const rowData = ref();
  // 获取详情
  async function getDetails(id: string) {
    if (getDetailsApi) {
      getDetailsApi(id).then((res) => {
        form.value = Object.assign({}, initFormParam, res?.data?.data);
        dataCallBack && (form.value = dataCallBack(form.value));
      });
    }
  }

  // 打开弹框
  async function openDialog(row: any, init) {
    if (row[idName]) {
      state.title = editTitle;
      state.id = row[idName];
      await getDetails(row[idName]);
    } else {
      state.title = addTitle;
      state.id = '';
    }
    state.isShow = true;
    form.value = { ...init };
    rowData.value = row;
    afterOpenDialog && afterOpenDialog(form.value, row);
  }

  // 关闭弹框
  function closeDialog() {
    state.isShow = false;
    form.value = { ...initFormParam };
  }

  return {
    ...toRefs(state),
    form,
    closeDialog,
    openDialog,
    rowData,
  };
}
